<a class="link" [href]="Href"><ng-content></ng-content></a>


// WEBPACK FOOTER //
// C:/Users/jjarvis/projects/pm-controls/source/app/controls/components/link/link.html